import { BasePaginationRespone } from '../../base/BasePaginationRespone';
import { BaseSelectRequest } from '../../base/BaseSelectRequest';
import { BaseShowDetail } from '../../base/BaseShowDetail';
import { IActionTypeBase } from '../../base/IBaseActionTypes';
import { CollectionGroupModel } from '../../models/collections/CollectionGroupModel';
import { CollectionGroupRequest } from '../../models/collections/CollectionGroupRequest';
import { CollectionGroupResponse } from '../../models/collections/CollectionGroupResponse';

export enum eCollectionGroupActionTypeIds {
	GET_ALL_REQUEST = 'CollectionGroup_GET_ALL_REQUEST',
	GET_ALL_SUCCESS = 'CollectionGroup_GET_ALL_SUCCESS',
	GET_ALL_FAILURE = 'CollectionGroup_GET_ALL_FAILURE',

	GET_PAGINATION_REQUEST = 'CollectionGroup_GET_PAGINATION_REQUEST',
	GET_PAGINATION_SUCCESS = 'CollectionGroup_GET_PAGINATION_SUCCESS',
	GET_PAGINATION_FAILURE = 'CollectionGroup_GET_PAGINATION_FAILURE',

	SAVE_REQUEST = 'CollectionGroup_SAVE_REQUEST',
	SAVE_SUCCESS = 'CollectionGroup_SAVE_SUCCESS',
	SAVE_FAILURE = 'CollectionGroup_SAVE_FAILURE',

	DELETE_REQUEST = 'CollectionGroup_DELETE_REQUEST',
	DELETE_SUCCESS = 'CollectionGroup_DELETE_SUCCESS',
	DELETE_FAILURE = 'CollectionGroup_DELETE_FAILURE',

	NEED_RELOAD = 'CollectionGroup_NEED_RELOAD',

	CHANGE_SELECTED_IDS = 'CollectionGroup_CHANGE_SELECTED_IDS',
	SHOW_DETAIL = 'CollectionGroup_SHOW_DETAIL',
	SHOW_CONFIRM = 'CollectionGroup_SHOW_CONFIRM',
}

export interface CollectionGroupAction_GETALL_Request extends IActionTypeBase<eCollectionGroupActionTypeIds.GET_ALL_REQUEST, CollectionGroupRequest> {}
export interface CollectionGroupAction_GETALL_Success
	extends IActionTypeBase<eCollectionGroupActionTypeIds.GET_ALL_SUCCESS, CollectionGroupResponse[]> {}
export interface CollectionGroupAction_GETALL_Failure
	extends IActionTypeBase<eCollectionGroupActionTypeIds.GET_ALL_FAILURE, Error | string> {}

export interface CollectionGroupAction_GETPAGINATION_Request
	extends IActionTypeBase<eCollectionGroupActionTypeIds.GET_PAGINATION_REQUEST, BaseSelectRequest> {}
export interface CollectionGroupAction_GETPAGINATION_Success
	extends IActionTypeBase<eCollectionGroupActionTypeIds.GET_PAGINATION_SUCCESS, BasePaginationRespone<CollectionGroupModel>> {}
export interface CollectionGroupAction_GETPAGINATION_Failure
	extends IActionTypeBase<eCollectionGroupActionTypeIds.GET_PAGINATION_FAILURE, Error | string> {}

export interface CollectionGroupAction_SAVE_Request
	extends IActionTypeBase<eCollectionGroupActionTypeIds.SAVE_REQUEST, CollectionGroupModel> {}
export interface CollectionGroupAction_SAVE_Success extends IActionTypeBase<eCollectionGroupActionTypeIds.SAVE_SUCCESS, string> {}
export interface CollectionGroupAction_SAVE_Failure extends IActionTypeBase<eCollectionGroupActionTypeIds.SAVE_FAILURE, Error | string> {}

export interface CollectionGroupAction_DELETE_Request extends IActionTypeBase<eCollectionGroupActionTypeIds.DELETE_REQUEST, number[]> {}
export interface CollectionGroupAction_DELETE_Success extends IActionTypeBase<eCollectionGroupActionTypeIds.DELETE_SUCCESS, string> {}
export interface CollectionGroupAction_DELETE_Failure
	extends IActionTypeBase<eCollectionGroupActionTypeIds.DELETE_FAILURE, Error | string> {}

export interface CollectionGroupAction_RELOAD extends IActionTypeBase<eCollectionGroupActionTypeIds.NEED_RELOAD, undefined> {}

export interface CollectionGroupAction_SHOW_DETAIL
	extends IActionTypeBase<eCollectionGroupActionTypeIds.SHOW_DETAIL, BaseShowDetail<CollectionGroupModel>> {}
export interface CollectionGroupAction_CHANGE_SELECTED_IDS
	extends IActionTypeBase<eCollectionGroupActionTypeIds.CHANGE_SELECTED_IDS, number[]> {}
export interface CollectionGroupAction_SHOW_CONFIRM extends IActionTypeBase<eCollectionGroupActionTypeIds.SHOW_CONFIRM, boolean> {}

export type CollectionGroupActionTypes =
	| CollectionGroupAction_GETALL_Request
	| CollectionGroupAction_GETALL_Success
	| CollectionGroupAction_GETALL_Failure
	| CollectionGroupAction_GETPAGINATION_Request
	| CollectionGroupAction_GETPAGINATION_Success
	| CollectionGroupAction_GETPAGINATION_Failure
	| CollectionGroupAction_SAVE_Request
	| CollectionGroupAction_SAVE_Success
	| CollectionGroupAction_SAVE_Failure
	| CollectionGroupAction_DELETE_Request
	| CollectionGroupAction_DELETE_Success
	| CollectionGroupAction_DELETE_Failure
	| CollectionGroupAction_RELOAD
	| CollectionGroupAction_SHOW_DETAIL
	| CollectionGroupAction_CHANGE_SELECTED_IDS
	| CollectionGroupAction_SHOW_CONFIRM;
